export {
  CopilotResizer, COPILOT_WIDTH, COPILOT_MAX_WIDTH, COPILOT_HEIGHT, COPILOT_RESIZER_PREFERENCE_KEY, getCopilotWidthFromPreference,
} from './components';
